<template>
  <div class="jobsAdd">
    <div class="ruleForm">
      <el-form :model="basic" :rules="rules" ref="basic" label-width="130px" class="demo-ruleForm">

        <el-form-item label="用户名" prop="oausername">
          <el-col :span="24">
            <el-input v-model="basic.oausername"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="性别" prop="sex">
          <el-col :span="24">
             <el-radio-group v-model="basic.sex">
                <el-radio border :label="1">男</el-radio>
                <el-radio border :label="2">女</el-radio>
              </el-radio-group>
          </el-col>
        </el-form-item>

        <el-form-item label="用户状态" prop="oastatus">
          <el-radio-group id="el-radio-group" v-model="basic.oastatus" size="medium">
            <el-radio border :label="2">在职</el-radio>
            <el-radio border :label="3">离职</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="入职时间" prop="oaentrytime">
          <el-col :span="24">
            <el-date-picker v-model="basic.oaentrytime" type="date" placeholder="选择日期" style="width: 100%;"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
        </el-form-item>


        <el-form-item label="离职时间" prop="oaleavetime" v-if="basic.oastatus == 3" >
          <el-col :span="24">
            <el-date-picker v-model="basic.oaleavetime" type="date" placeholder="选择日期" style="width: 100%;"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-col :span="24">
            <el-input editable v-model="basic.email"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="电话" prop="oamobile">
          <el-col :span="24">
            <el-input editable v-model="basic.oamobile"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="密码:" prop="oapassword">
          <el-input type="password" v-model="basic.oapassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="确认密码:" prop="oarepassword">
          <el-input type="password" v-model="basic.oarepassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="qq" prop="qq">
          <el-col :span="24">
            <el-input editable v-model="basic.qq"></el-input>
          </el-col>
        </el-form-item>


       <el-form-item label="部门和职位" >
          <el-col :span="11">
         <el-form-item  prop="department_name">
           <el-select v-model="basic.department_name" placeholder="请选择部门" @change="selectDepartmentChange">
             <el-option :label="item.department_name" :value="[item.deparment_id,item.department_name,item.children]" v-for='(item,index) in AuthDepartmentList' :key='index'></el-option>
           </el-select>
         </el-form-item>
        </el-col>
        <el-col :span="2" style="text-align: center;">-</el-col>
         <el-col :span="11">
         <el-form-item prop="oajobname">
           <el-select v-model="basic.oajobname" placeholder="请选择职位" @change="oajobnameChange">
             <el-option :label="item.name" :value="[item.id,item.name]" v-for='(item,index) in AuthList' :key='index'></el-option>
           </el-select>
         </el-form-item>
         </el-col>
       </el-form-item>

        <el-form-item label="小程序数据权限" prop="datadepartmenttype">
          <el-col :span="24">
            <el-radio-group v-model="basic.datadepartmenttype" @change='datadepartmenttypeChange'>
              <el-radio :label="1">全部部门</el-radio>
              <el-radio :label="2">分部</el-radio>
              <el-radio :label="3">个人</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>


        <el-form-item label="" v-if="basic.datadepartmenttype == 2">
          <el-col :span="24">
            <el-checkbox-group v-model="datadepartment" @change='departMentChanges'>
              <el-checkbox :label="item.id + ''" v-for='(item,index) in departmentList' :key='index' >{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item>

        <!--      <el-form-item label="工作职位" prop="oajobname">
          <el-select v-model="basic.oajobname" placeholder="请选择工作职位" @change="oajobnameChange">
            <el-option :label="item.name" :value="[item.id,item.name]" v-for='(item,index) in workList' :key='index'></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="工作地点">
          <el-col :span="24">
            <el-input v-model="basic.oaplace"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="是否司机" prop="is_driver">
          <el-col :span="24">
             <el-radio-group v-model="basic.is_driver">
                <el-radio border :label="1">是</el-radio>
                <el-radio border :label="0">否</el-radio>
              </el-radio-group>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('basic')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (this.uid) {
          if (this.basic.oarepassword !== "") {
            this.$refs.basic.validateField("oarepassword");
          }
          callback();

        } else {
          if (value === "") {
            callback(new Error("请输入密码"));
          } else {
            if (this.basic.oarepassword !== "") {
              this.$refs.basic.validateField("oarepassword");
            }
            callback();
          }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (this.uid) {
          if (!this.basic.oapassword && !value) {
            callback();
          }
          if (value === "") {
            callback(new Error("请再次输入密码"));
          } else if (value !== this.basic.oapassword) {
            callback(new Error("两次输入密码不一致!"));
          } else {
            callback();
          }
        } else {
          if (value !== this.basic.oapassword) {
            callback(new Error("两次输入密码不一致!"));
          } else {
            callback();
          }
        }
      };
      // 手机号验证
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
        setTimeout(() => {
          if (!Number.isInteger(+value)) {
            callback(new Error("请输入数字值"));
          } else {
            if (phoneReg.test(value)) {
              callback();
            } else {
              callback(new Error("电话号码格式不正确"));
            }
          }
        }, 100);
      };

      return {
        rules: {
          oapassword: [{
            validator: validatePass,
            trigger: "blur"
          }],
          oarepassword: [{
            validator: validatePass2,
            trigger: "blur"
          }],
          oausername: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }],
          oastatus: [{
            required: true,
            message: "请选择用户状态",
            trigger: "change"
          }],
          email: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }],
          oaentrytime: [{
            required: true,
            message: "请选择入职时间",
            trigger: "blur"
          }],
          oamobile: [{
            required: true,
            validator: checkPhone,
            trigger: "blur"
          }],
          qq: [{
            required: true,
            message: "请输入qq",
            trigger: "blur"
          }],
          department_name: [{
            required: true,
            message: "请选择所属部门",
            trigger: "change"
          }],
          // oatype: [{
          //   required: true,
          //   message: "请选择所属角色",
          //   trigger: "change"
          // }],
          // oaparentname: [{
          //   required: true,
          //   message: "请选择上级",
          //   trigger: "change"
          // }],
          oajobname: [{
            required: true,
            message: "请选择工作职位",
            trigger: "change"
          }],
          datadepartmenttype: [{
            required: true,
            message: "请选择部门类型",
            trigger: "change"
          }],
          // datadepartment: [{
          //   required: true,
          //   message: "请选择部门",
          //   trigger: "change"
          // }],
          oaleavetime:[{
            required: true,
            message: "请选择离职时间",
            trigger: "blur"
          }],
          sex:[{
            required: true,
            message: "请选择性别",
            trigger: "change"
          }]
        },
        optionList: [],
        current: {},
        basic: {
          oausername: "",
          oastatus: "",
          sex:'',
          email: "",
          oamobile: "",
          qq: "",
          oatype: "",
          oapassword: "",
          oarepassword: "",
          oaleavetime:'',
          oaentrytime: '',
          department: '',
          department_name: '',
          oajobname: '',
          oajobid: '',
          oaplace: '',
          oaparentid: '',
          oaparentname: '',
          datadepartment: [],
          datadepartmenttype:'',
          is_driver:0,
        },
        focusVal: 0,
        myHeaders: {},
        uid: "",
        departmentList: [],
        workList: [],
        oaparentList: [],
        AuthList: [],
        AuthDepartmentList:[],
        datadepartment: [],
        datadepartmenttype:''
      };

    },
    activated() {
      this.uid = this.$route.query.uid;
      // 获取token
      let token = this.$store.state.token;
      // 获取token
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };

      if (this.uid) {
        this.gets('oasystem/departmentlist').then(res => {
          this.departmentList = res.data.data
          this.getData()
        })

      } else {
        // this.basic = {
        //   oausername: "",
        //   oastatus: "",
        //   email: "",
        //   oaleavetime:'',
        //   oamobile: "",
        //   qq: "",
        //   oatype: "",
        //   oapassword: "",
        //   oarepassword: ""
        // }
      }

    },
    mounted() {
      this.getDepartMent()
      // this.getWorkList()
      // this.getOaparentList()
      this.getPositionList()
    },
    methods: {

      datadepartmenttypeChange(e){
        this.basic.datadepartmenttype = e
      },

      oaparentChange(val) {
        this.basic.oaparentid = val[0]
        this.basic.oaparentname = val[1]
        this.$forceUpdate()
      },

      getOaparentList() {
        this.gets('oasystem/cateadminlist').then(res => {
          this.oaparentList = res.data.data
        })
      },

      getWorkList() {
        this.gets('oasystem/joblist').then(res => {
          this.workList = res.data.data
        })
      },


      getData() {
        //角色详情信息
        this.gets("oasystem/admininfo?id=" + this.uid).then((res) => {

          for(let key in this.basic) {
            if( !(res.data.data[key]==undefined || typeof(res.data.data[key]) == undefined) ){
              this.basic[key] = res.data.data[key]
            }

          }

          //this.basic = res.data.data;
          //this.basic.oatypeName = res.data.data.oatype == 2 ? '招聘专员' : '司机'
          this.datadepartment = res.data.data.datadepartment,
          this.datadepartmenttype = res.data.data.datadepartmenttype
          // this.departmentList.map((item => {
          //   if (item.id == res.data.data.department) {
          //     this.basic.department_name = item.name
          //   }
          // }))
          this.AuthDepartmentList.map((item => {
            if (item.deparment_id == res.data.data.department) {
              this.basic.department_name = item.department_name
              this.AuthList = item.children
            }
          }))
          if (!this.basic.oapassword) {
            this.basic.oapassword = ''
          }
        });
      },
      submitForm(formName) {

        this.$refs[formName].validate((valid) => {
          console.log(valid)
          if (valid) {
            console.log("提交")
            if (this.uid) {
              this.basic.id = this.uid
              if (!this.basic.oapassword) {
                this.basic.oapassword = ''
              }
            }
            // if(!this.basic.datadepartment || this.basic.datadepartment.length == 0){
            //   return Message.warning('请选择部门')
            // }
            this.post("oasystem/addadmin", this.basic).then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  this.$router.go(-1);
                } else {
                  Message.warning(res.data.msg);
                  return;
                }
              })
              .catch((err) => {
                Message.error(err.data.message);
              });
          } else {
            return false;
          }
        });
      },

      getDepartMent() {
        this.gets('oasystem/departmentlist').then(res => {
          this.departmentList = res.data.data
        })
      },
      //选择工作部门
      selectDepartmentChange(val) {
        this.basic.department = val[0]
        this.basic.department_name = val[1]
        this.AuthList = val[2]
        this.basic.oajobid = ''
        this.basic.oajobname = ''
      },

      oajobnameChange(val) {
        this.basic.oajobid = val[0]
        this.basic.oajobname = val[1]
      },

      getPositionList() {
        this.gets('common/getDepartmentAndJobs').then(res => {
          this.AuthDepartmentList = res.data.data
        })
      },

      departMentChanges(e) {
        this.basic.datadepartment = e
      },
    },
  };
</script>

<style scoped>
  .jobsAdd .el-checkbox {
    width: auto
  }

  .ruleForm /deep/ .el-radio__input.is-checked .el-radio__inner::after {
      content: '';
      width: 8px;
      height: 4px;
      border: 1px solid white;
      border-top: transparent;
      border-right: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 3px;
      left: 2px;
      vertical-align: middle;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
  }

  .jobsAdd .el-checkbox-group{
    margin: 0;
  }

  .jobsAdd .el-checkbox{
    margin: 0 25px 15px 0;
  }

</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/oaadminEdit.vue